<ion-list>
    <ion-item *ngFor="let tool of tools" (click)="execute(tool)" [translate]="tool.text"></ion-item>
</ion-list>
